import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, toRefs } from 'vue'
import { parseMetricForBackend } from '~/functions/metrics'
import type { MetricType } from '~/types/types'
import {
  useAddMetricAssignmentBatchMutation,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'AssignmentBatchDialog',
  props: {
  ventureId: {
    type: String,
    default: '',
  },
  impactId: {
    type: Number,
    default: null,
  },
  type: {
    type: String,
    default: 'add',
  },
  selectedMetrics: {
    type: Array as PropType<MetricType[]>,
    default: () => [],
  },
},
  emits: ["finish"],
  setup(__props, { emit }: { emit: ({
  (e: 'finish', val: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { ventureId, impactId, type, selectedMetrics } = toRefs(props)

const commentMapping = ref<Record<string, string>>({})

const {
  mutate: addMetricAssignmentBatch,
  loading: addMetricAssignmentBatchLoading,
} = useAddMetricAssignmentBatchMutation()

const submit = async () => {
  const metrics = selectedMetrics.value ?? []
  const inputs = metrics
    .map(parseMetricForBackend)
    .map((metric: MetricType) => {
      const comment =
        metric?.id && commentMapping.value[metric.id]
          ? commentMapping.value[metric.id]
          : null
      return {
        assigneeId: ventureId.value,
        metricId: metric?.id,
        comment,
        impactIds: impactId.value ? [impactId.value] : [],
        isFrozen: false,
      }
    })
  const resp = await addMetricAssignmentBatch({
    inputs,
  })
  emit('finish', resp?.data?.addMetricAssignmentBatch || [])
}


return { __sfc: true,props, emit, ventureId, impactId, type, selectedMetrics, commentMapping, addMetricAssignmentBatch, addMetricAssignmentBatchLoading, submit }
}

})